// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GA1SzT {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}

.svcM2H {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.mGE5E4 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.uLvNYN {
  display: flex;
  flex-direction: column;
}

.Upkzhc {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.YAmN__ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-100);
  letter-spacing: 0px;
  color: var(--status-error, #dc0a0a);
  margin: var(--spacing-1) 0 0 0;
  padding: 0;
}

.h8FqpF {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/Onboarding/components/CpfValidation/CpfValidation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb","sourcesContent":[".cpfValidationWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cpfValidationTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.cpfValidationSubtitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.cpfValidationField {\n  display: flex;\n  flex-direction: column;\n}\n\n.cpfValidationInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.cpfValidationContactError {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-100);\n  letter-spacing: 0px;\n  color: var(--status-error, #dc0a0a);\n  margin: var(--spacing-1) 0 0 0;\n  padding: 0;\n}\n\n.cpfValidationActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cpfValidationWrapper": `GA1SzT`,
	"cpfValidationTitle": `svcM2H`,
	"cpfValidationSubtitle": `mGE5E4`,
	"cpfValidationField": `uLvNYN`,
	"cpfValidationInputWrapper": `Upkzhc`,
	"cpfValidationContactError": `YAmN__`,
	"cpfValidationActions": `h8FqpF`
};
module.exports = ___CSS_LOADER_EXPORT___;
